import { Module } from "vuex";
import {
  TaskGroup,
  getProjectTasks,
  saveTaskGroup,
  deleteTaskGroup,
  saveTask,
  // addNewTask,
  deleteTask,
  addEmptyRow,
  changeTaskSchedule
} from "@/api/task-api";
import RootState from "./root-state";
import { sortTaskGroups } from "@/api/task-api";
import TaskFormData from "@/api/models/TaskFormData";

interface TaskState {
  taskGroups: TaskGroup[];
}

const task: Module<TaskState, RootState> = {
  state: {
    taskGroups: []
  },
  getters: {
    taskGroups: state => state.taskGroups
  },
  mutations: {},
  actions: {
    async getProjectTasks({ state, rootState }) {
      state.taskGroups = await getProjectTasks(rootState.projectId);
    },
    async saveTaskGroup({ rootState, dispatch }, data: FormData) {
      await saveTaskGroup(data);
      dispatch("member/load-workers", rootState.projectId);
      await dispatch("getProjectTasks", rootState.projectId);
    },
    async sortTaskGroups({ state, rootState }, taskGroups: TaskGroup[]) {
      // TODO taskGroupsの書き換えもできてしまうが何か制限したほうがいいか？
      state.taskGroups = taskGroups;
      await sortTaskGroups(
        rootState.projectId,
        taskGroups.map(g => g.taskGroupId)
      );
      // 自前でも並べ替えるので取得し直さない
      // await dispatch("getProjectTasks", rootState.projectId);
    },
    async addNewTaskGroup({ rootState, dispatch }) {
      await addEmptyRow(rootState.projectId);
      await dispatch("getProjectTasks", rootState.projectId);
    },
    async deleteTaskGroup({ rootState, dispatch }, taskGroupId: string) {
      await deleteTaskGroup(taskGroupId);
      await dispatch("getProjectTasks", rootState.projectId);
    },
    async saveTask({ rootState, dispatch }, data: FormData) {
      await saveTask(data);
      await dispatch("getProjectTasks", rootState.projectId);
    },
    // async addNewTask({ rootState, dispatch }, { taskGroupId, start }) {
    //   const id = await addNewTask(taskGroupId, start);
    //   await dispatch("getProjectTasks", rootState.projectId);
    //   return id;
    // },
    async moveTask({ dispatch }, { task, start }) {
      const t = changeTaskSchedule(task, start);
      const d = TaskFormData(t);
      await dispatch("saveTask", d);
    },
    async deleteTask({ rootState, dispatch }, taskId: string) {
      await deleteTask(taskId);
      await dispatch("getProjectTasks", rootState.projectId);
    }
  }
};

export default task;
